export const listOptions = {
    initialStartIndex: 1,
    pageSize: 20
};
